import React from 'react';
import { oneOf, string, object, node } from 'prop-types';
import cx from 'classnames';

const CLASS_ROOT = 'card__section';

const propTypes = {
  type: oneOf(['image']),
  bgSrc: string,
  style: object,
  date: string,
  renderDate: node,
};

const CardSection = ({
  className,
  children,
  style,
  type,
  bgSrc,
  date,
  renderDate,
  ...other
}) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`card__${type}`]: type,
    },
    className,
  );

  /* eslint-disable */
  const renderDateBadge =
    (date && <div className="card__date">{date}</div>) ||
    (renderDate && renderDate);
  /* eslint-enable */

  return (
    <div
      className={classes}
      {...bgSrc && { style: { backgroundImage: `url(${bgSrc})`, ...style } }}
      {...other}
    >
      {renderDateBadge} {children}
    </div>
  );
};

CardSection.propTypes = propTypes;

export default CardSection;
